module.exports = __webpack_public_path__ + "static/media/kh.ae60a7f6.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/kh.svg
// module id = 1271
// module chunks = 0